import { DialogService, GridAction } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { AssignedStaffDialog, PersonDialog, PersonDialogData } from '../../../../../../ui/widget';
import { AssignedStaffDialogResult, VolunteerDialog } from '../../../../../../ui/widget/dialog';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { VolunteeringProspectsService } from '../../../volunteering-prospects.service';

export function getActions(service: VolunteeringProspectsService, dialogService: DialogService, areaService: VolunteeringAreaService) {

	const actions: GridAction<VolunteerProspect>[] = [
		{
			iconClass: 'fa-regular fa-user-tie',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
				await service.getAllClosedVolunteers();
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.person.id, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View All Engagements',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: PersonDialogData = { personId: rows[0]!.person.id, toEdit: false, tab: 'engagements' };
				await dialogService.showCustom(PersonDialog, { data: dialogData }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-gear',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (areaService.canManageVolunteerStaff()) return !!rows.length;
				return false;
			},
			execute: async rows => {
				const volunteerName = rows[0]?.person.fullName;
				const staffId = rows[0]?.assignedToStaffId || 0;
				const action = await dialogService.showCustom(AssignedStaffDialog, {
					data: {
						headerText: volunteerName!,
						staffId: staffId
					}
				}, 800, 300);

				const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
				if (result) {
					await areaService.updateAssignedStaffForVolunteer(rows[0]!.volunteerId, result.staffId);
					await service.getAllClosedVolunteers();
				}
			}
		},
	];

	return actions;
}

